import { showMessage } from 'utils/actions/globalMessaging'
import {
  RESEND_INVITE_ACTION_TYPES,
  DELETE_USER_ACTION_TYPES,
  APPROVE_PARENT_USER_ACTION_TYPES,
  REJECT_PARENT_USER_ACTION_TYPES,
} from 'utils/actions/user'

export const user = store => next => async action => {
  if (action.type === RESEND_INVITE_ACTION_TYPES.RESEND_INVITE_SUCCESS) {
    store.dispatch(
      showMessage('Ask them to check their email inbox.', { type: 'info', typeLabel: 'Sent!' })
    )
  }
  if (action.type === RESEND_INVITE_ACTION_TYPES.RESEND_INVITE_FAILURE) {
    store.dispatch(
      showMessage(`There was an error resending the invite. ${action.payload.errors}`, {
        type: 'alert',
      })
    )
  }

  if (action.type === DELETE_USER_ACTION_TYPES.DELETE_USER_SUCCESS) {
    store.dispatch(showMessage('User has been deleted.', { type: 'info' }))
  }

  if (action.type === APPROVE_PARENT_USER_ACTION_TYPES.APPROVE_PARENT_USER_SUCCESS) {
    store.dispatch(showMessage('User has been approved.', { type: 'info' }))
  }
  if (action.type === APPROVE_PARENT_USER_ACTION_TYPES.APPROVE_PARENT_USER_FAILURE) {
    store.dispatch(showMessage('Failed to approve user.', { type: 'alert' }))
  }

  if (action.type === REJECT_PARENT_USER_ACTION_TYPES.REJECT_PARENT_USER_SUCCESS) {
    store.dispatch(showMessage('User has been rejected.', { type: 'info' }))
  }
  if (action.type === REJECT_PARENT_USER_ACTION_TYPES.REJECT_PARENT_USER_FAILURE) {
    store.dispatch(showMessage('Failed to reject user.', { type: 'alert' }))
  }

  return next(action)
}
